module.exports = __webpack_public_path__ + "static/img/car.b0f49d0e.png";